export class ProductSwatches extends window.BAO.CustomElement() {
  constructor () {
    super()

    // Already rendered server-side (product-card section)
    if (this.querySelector('.prd-Swatches')) return

    // Hidden or off-screen swatches (e.g. a display: none carousel) never
    // intersect, so only fetch once they're close to being seen.
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return

        observer.disconnect()
        this.load()
      },
      { rootMargin: '200px' },
    )
    observer.observe(this)
  }

  load () {
    const { sectionRenderer } = window.BAO

    sectionRenderer
      .fetchSingle('product-swatches', `${this.getAttribute('data-url')}`)
      .then(html => {
        this.innerHtml = this.innerHTML = sectionRenderer.getOuterHtml(html, {
          id: 'shopify-section-product-swatches',
          selector: '.prd-Swatches',
        })
      })
  }
}

if (!customElements.get('product-swatches')) {
  customElements.define('product-swatches', ProductSwatches)
}
